module.exports = __webpack_public_path__ + "static/aon-metaImage@2x-de1f8e486caae6cce393953c6b505326.png";